import {
  IIntegration,
  IntegrationStorage,
  IntegrationType,
} from '@principle-theorem/integrations';
import {
  IPractice,
  IViaApiIntegrationData,
  SenderType,
} from '@principle-theorem/principle-core/interfaces';
import {
  CollectionReference,
  DocumentReference,
} from '@principle-theorem/shared';
import { resolveOrganisationFromSender } from '../interaction/send-sms-request';
import { Organisation } from '../organisation/organisation';

export class ViaApiIntegrationStorage extends IntegrationStorage<IViaApiIntegrationData> {
  constructor() {
    super(IntegrationType.ViaApi);
  }

  static init(data: Partial<IViaApiIntegrationData>): IViaApiIntegrationData {
    return {
      enabled: false,
      ...data,
    };
  }

  static isEnabled(data?: IViaApiIntegrationData): boolean {
    return !!data?.enabled;
  }

  override async upsert(
    integrationsCollection: CollectionReference<
      IIntegration<IViaApiIntegrationData>
    >,
    data: Partial<IViaApiIntegrationData>
  ): Promise<void> {
    const current = await this.get(integrationsCollection);
    return super.upsert(
      integrationsCollection,
      ViaApiIntegrationStorage.init({ ...current?.data, ...data })
    );
  }
}

export async function resolveViaApiIntegrationSettings(
  practiceRef: DocumentReference<IPractice>
): Promise<IViaApiIntegrationData | undefined> {
  const org = await resolveOrganisationFromSender({
    type: SenderType.Practice,
    ref: practiceRef,
  });
  const integrationsCol =
    Organisation.integrationCol<IViaApiIntegrationData>(org);
  const storage = new ViaApiIntegrationStorage();
  const data = await storage.get(integrationsCol);
  return data?.data;
}
